import './storefront.tw.css';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import QuickPersonalizer from './QuickPersonalizer.ce.vue';
import TemplateMockupManager from './TemplateMockupManager.ce.vue';

const QuickPersonalizerElement = defineCustomElement(QuickPersonalizer, {
  shadowRoot: false,
  configureApp(app) {
    app.use(createPinia());
  },
});

if (!customElements.get('veyo-quick-personalizer')) {
  customElements.define('veyo-quick-personalizer', QuickPersonalizerElement);
}

// Product-edit screen only; shares this bundle because the canvas render pipeline
// it needs is already here for the Quick Personalizer.
const TemplateMockupManagerElement = defineCustomElement(TemplateMockupManager, {
  shadowRoot: false,
  configureApp(app) {
    app.use(createPinia());
  },
});

if (!customElements.get('veyo-template-mockup')) {
  customElements.define('veyo-template-mockup', TemplateMockupManagerElement);
}

